<template>
  <div class="selected" style="margin-bottom: 30px;">
    <div class="row mb-5">
      <div class="col">
        <h2>{{ $t("contact") }}</h2>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary btn-small" @click="progress.contact.overview = false; progress.contact.show = true; scrollToElement(progress.contact.name);">
          {{ $t("edit") }}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 contact-summary">
        <p class="mb-2">{{ reservation.contact.firstname }}
        {{ reservation.contact.lastname }}</p>
        <p class="mb-2">{{ reservation.contact.street }} {{ reservation.contact.zip }}
        {{ reservation.contact.city }} </p>
        <p class="mb-0">{{ reservation.contact.country }}
        {{ reservation.contact.email }}</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "OrderFormSummary",
  inject: ["reservation", "progress"],

  data() {
    return {
      temp: null,

      showGuest: false,
    };
  },
};
</script>